// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Icon from "../../resources/images-and-icons/Icon.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as React from "react";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";

function toLabel(status) {
  if (typeof status === "object") {
    return I18n.t("Archived");
  }
  switch (status) {
    case "Active" :
      return I18n.t("On sale");
    case "Inactive" :
      return I18n.t("Unlisted");
    case "Unarchived" :
      return I18n.t("Not archived");
  }
}

function toString(status) {
  if (typeof status === "object") {
    return "ARCHIVED";
  }
  switch (status) {
    case "Active" :
      return "ACTIVE";
    case "Inactive" :
      return "INACTIVE";
    case "Unarchived" :
      return "UNARCHIVED";
  }
}

function fromString(str) {
  switch (str) {
    case "ACTIVE" :
      return {
        TAG: "Ok",
        _0: "Active"
      };
    case "ARCHIVED" :
      return {
        TAG: "Ok",
        _0: {
          TAG: "Archived",
          _0: undefined
        }
      };
    case "INACTIVE" :
      return {
        TAG: "Ok",
        _0: "Inactive"
      };
    case "UNARCHIVED" :
      return {
        TAG: "Ok",
        _0: "Unarchived"
      };
    default:
      return {
        TAG: "Error",
        _0: "Invalid product status"
      };
  }
}

function toStyleSet(status) {
  if (typeof status !== "object") {
    switch (status) {
      case "Active" :
        return {
          bgColor: "#CEFDE0",
          textColor: "#00653E",
          borderColor: "#66EFAC",
          iconSvg: JsxRuntime.jsx(Icon.make, {
            name: "product_ok",
            fill: "#00653E",
            width: 11,
            height: 11,
            bold: true
          })
        };
      case "Inactive" :
        return {
          bgColor: "#FFE5CF",
          textColor: "#7C2112",
          borderColor: "#FDAB74",
          iconSvg: JsxRuntime.jsx(Icon.make, {
            name: "product_nok",
            fill: "#7C2112",
            width: 11,
            height: 11,
            bold: true
          })
        };
      case "Unarchived" :
        break;
    }
  }
  return {
    bgColor: "#E7E7EE",
    textColor: "#25243A",
    borderColor: "#A2A1B0",
    iconSvg: JsxRuntime.jsx(Icon.make, {
      name: "archive",
      fill: "#25243A",
      width: 11,
      height: 11,
      bold: true
    })
  };
}

let make = React.memo(props => {
  let __size = props.size;
  let value = props.value;
  let size = __size !== undefined ? __size : "medium";
  let styleSet = toStyleSet(value);
  let badge = JsxRuntime.jsx(Badge.make, {
    children: toLabel(value),
    iconSvg: styleSet.iconSvg,
    size: size,
    borderColor: styleSet.borderColor,
    backgroundColor: styleSet.bgColor,
    foregroundColor: styleSet.textColor
  });
  if (typeof value !== "object") {
    return badge;
  }
  let archivedAt = value._0;
  if (archivedAt === undefined) {
    return badge;
  }
  let formattedDate = DateHelpers.formateToShortDate(archivedAt);
  let formattedTime = DateHelpers.formateToShortTime(undefined, archivedAt);
  return JsxRuntime.jsx(Tooltip.make, {
    children: badge,
    placement: "top",
    content: JsxRuntime.jsx(Tooltip.Span.make, {
      text: I18n.template(I18n.t("Archived on {{date}} at {{time}}"), {
        date: formattedDate,
        time: formattedTime
      }, undefined)
    })
  });
});

let Badge$1 = {
  toStyleSet: toStyleSet,
  make: make
};

let Status = {
  toLabel: toLabel,
  toString: toString,
  fromString: fromString,
  FeedbackBadge: undefined,
  Badge: Badge$1
};

function toLabel$1(titleCaseOpt, translateOpt, kind) {
  let titleCase = titleCaseOpt !== undefined ? titleCaseOpt : false;
  let translate = translateOpt !== undefined ? translateOpt : true;
  let label = kind === "SPIRITUOUS" ? "spirituous" : (
      kind === "BEER" ? "beer" : (
          kind === "WINE" ? "wine" : "simple product"
        )
    );
  let label$1 = translate ? I18n.t(label) : label;
  if (titleCase) {
    return label$1.charAt(0).toUpperCase() + label$1.slice(1);
  } else {
    return label$1;
  }
}

function toString$1(kind) {
  return kind;
}

function fromString$1(str) {
  switch (str) {
    case "BEER" :
      return {
        TAG: "Ok",
        _0: "BEER"
      };
    case "SIMPLE" :
      return {
        TAG: "Ok",
        _0: "SIMPLE"
      };
    case "SPIRITUOUS" :
      return {
        TAG: "Ok",
        _0: "SPIRITUOUS"
      };
    case "WINE" :
      return {
        TAG: "Ok",
        _0: "WINE"
      };
    default:
      return {
        TAG: "Error",
        _0: "Invalid kind"
      };
  }
}

let Kind = {
  toLabel: toLabel$1,
  toString: toString$1,
  fromString: fromString$1
};

function toLabel$2(x) {
  if (x === "ORANGE") {
    return I18n.t("Orange");
  } else if (x === "RED") {
    return I18n.t("Red");
  } else if (x === "AMBER") {
    return I18n.t("Amber");
  } else if (x === "DARK") {
    return I18n.t("Dark");
  } else if (x === "BLACK") {
    return I18n.t("Black");
  } else if (x === "BLOND") {
    return I18n.t("Blond");
  } else if (x === "ROSE") {
    return I18n.t("Rose");
  } else {
    return I18n.t("White");
  }
}

function toColorSet(value, variation) {
  if (value === "BLOND" || value === "ORANGE") {
    return {
      foregroundColor: "#dd8700",
      backgroundColor: "#f8e7cc"
    };
  } else if (value === "RED") {
    return {
      foregroundColor: "#a01e72",
      backgroundColor: "#f5E8f0"
    };
  } else if (value === "AMBER") {
    return {
      foregroundColor: "#982d1f",
      backgroundColor: "#ead5d2"
    };
  } else if (value === "DARK") {
    return {
      foregroundColor: "#5f0f0c",
      backgroundColor: "#ffcfce"
    };
  } else if (value === "BLACK") {
    return {
      foregroundColor: "#300c0a",
      backgroundColor: "#ead5d2"
    };
  } else if (value === "ROSE") {
    return {
      foregroundColor: "#e87582",
      backgroundColor: "#fce5e8"
    };
  } else if (variation === "pastille") {
    return {
      foregroundColor: "#EED87A",
      backgroundColor: "#EED87A"
    };
  } else {
    return {
      foregroundColor: "#907b1e",
      backgroundColor: "#fff4cc"
    };
  }
}

function toString$2(color) {
  return color;
}

function fromString$2(str) {
  switch (str) {
    case "AMBER" :
      return {
        TAG: "Ok",
        _0: "AMBER"
      };
    case "BLACK" :
      return {
        TAG: "Ok",
        _0: "BLACK"
      };
    case "BLOND" :
      return {
        TAG: "Ok",
        _0: "BLOND"
      };
    case "DARK" :
      return {
        TAG: "Ok",
        _0: "DARK"
      };
    case "ORANGE" :
      return {
        TAG: "Ok",
        _0: "ORANGE"
      };
    case "RED" :
      return {
        TAG: "Ok",
        _0: "RED"
      };
    case "ROSE" :
      return {
        TAG: "Ok",
        _0: "ROSE"
      };
    case "WHITE" :
      return {
        TAG: "Ok",
        _0: "WHITE"
      };
    default:
      return {
        TAG: "Error",
        _0: "Invalid color"
      };
  }
}

let Color = {
  toLabel: toLabel$2,
  toColorSet: toColorSet,
  toString: toString$2,
  fromString: fromString$2
};

function toLabel$3(x) {
  if (x === "EFFERVESCENT") {
    return I18n.t("Effervescent");
  } else {
    return I18n.t("Still");
  }
}

function toString$3(wineType) {
  return wineType;
}

function fromString$3(str) {
  switch (str) {
    case "EFFERVESCENT" :
      return {
        TAG: "Ok",
        _0: "EFFERVESCENT"
      };
    case "STILL" :
      return {
        TAG: "Ok",
        _0: "STILL"
      };
    default:
      return {
        TAG: "Error",
        _0: "Invalid wine type"
      };
  }
}

let WineType = {
  toLabel: toLabel$3,
  toString: toString$3,
  fromString: fromString$3
};

function toLabel$4(x) {
  if (x === "SWEET") {
    return I18n.t("Sweet");
  } else if (x === "SEMIDRY") {
    return I18n.t("Semi dry");
  } else if (x === "SOFT") {
    return I18n.t("Soft");
  } else {
    return I18n.t("Dry");
  }
}

function toString$4(whiteWineType) {
  return whiteWineType;
}

function fromString$4(str) {
  switch (str) {
    case "DRY" :
      return {
        TAG: "Ok",
        _0: "DRY"
      };
    case "SEMIDRY" :
      return {
        TAG: "Ok",
        _0: "SEMIDRY"
      };
    case "SOFT" :
      return {
        TAG: "Ok",
        _0: "SOFT"
      };
    case "SWEET" :
      return {
        TAG: "Ok",
        _0: "SWEET"
      };
    default:
      return {
        TAG: "Error",
        _0: "Invalid white wine type"
      };
  }
}

let WhiteWineType = {
  toLabel: toLabel$4,
  toString: toString$4,
  fromString: fromString$4
};

function formatDescription(productKind, information, hideColorOpt, hideProducerOpt, hideSupplierOpt, param) {
  let hideColor = hideColorOpt !== undefined ? hideColorOpt : false;
  let hideProducer = hideProducerOpt !== undefined ? hideProducerOpt : false;
  let hideSupplier = hideSupplierOpt !== undefined ? hideSupplierOpt : false;
  let match = information.sku;
  let match$1 = information.internalCode;
  let formattedSkuCode = match !== undefined ? (
      match$1 !== undefined ? (
          match === match$1 ? `SKU/CODE` + I18n.t(":") + ` ` + match : `SKU` + I18n.t(":") + ` ` + match + `, CODE` + I18n.t(":") + ` ` + match$1
        ) : `SKU` + I18n.t(":") + ` ` + match
    ) : (
      match$1 !== undefined ? `CODE` + I18n.t(":") + ` ` + match$1 : undefined
    );
  let country = information.country;
  let region = information.region;
  let designation = information.designation;
  let color = Stdlib_Option.flatMap(information.color, color => {
    if (!hideColor) {
      return toLabel$2(color);
    }
  });
  let producerName = Stdlib_Option.flatMap(information.producerName, producerName => {
    if (!hideProducer) {
      return producerName;
    }
  });
  let supplierName = Stdlib_Option.flatMap(information.supplierName, supplierName => {
    if (!hideSupplier) {
      return supplierName;
    }
  });
  let supplierName$1 = supplierName !== undefined && producerName !== undefined ? (
      supplierName.toLowerCase() !== producerName.toLowerCase() ? supplierName : undefined
    ) : supplierName;
  let designation$1 = designation !== undefined && region !== undefined ? (
      designation.toLowerCase() !== region.toLowerCase() ? designation : undefined
    ) : designation;
  let descriptionValues = productKind === "SPIRITUOUS" ? [
      formattedSkuCode,
      producerName,
      supplierName$1,
      information.productFamily,
      country
    ] : (
      productKind === "BEER" ? [
          color,
          formattedSkuCode,
          producerName,
          supplierName$1,
          information.beerType,
          country
        ] : (
          productKind === "WINE" ? [
              color,
              formattedSkuCode,
              producerName,
              supplierName$1,
              designation$1,
              region,
              country
            ] : [
              formattedSkuCode,
              producerName,
              supplierName$1,
              country
            ]
        )
    );
  return Stdlib_Array.filterMap(descriptionValues, x => x).join(", ");
}

let Information = {
  formatDescription: formatDescription
};

export {
  Status,
  Kind,
  Color,
  WineType,
  WhiteWineType,
  Information,
}
/* make Not a pure module */
